import type {
  TableDataHook,
  ItemsDataHook,
  IntegrationDataHook,
  CellRenderersHook,
  RowClickHook,
} from "./types";

/**
 * Registry for a schema source's hook getters.
 * Each schema source (integration module or page) can provide getters for
 * table data, integration data, cell renderers, and row click hooks.
 */
export interface SchemaHookRegistry {
  getTableDataHook?: (
    integrationName: string,
    clientId?: string
  ) => TableDataHook | undefined;
  getItemsDataHook?: (
    integrationName: string,
    clientId?: string
  ) => ItemsDataHook | undefined;
  getIntegrationDataHook?: (
    integrationName: string
  ) => IntegrationDataHook | undefined;
  getCellRenderersHook?: (
    integrationName: string
  ) => CellRenderersHook | undefined;
  getRowClickHook?: (
    integrationName: string
  ) => RowClickHook | undefined;
}

/** @deprecated Use SchemaHookRegistry */
export type ModuleHookRegistry = SchemaHookRegistry;

const schemaRegistries = new Map<string, SchemaHookRegistry>();

/**
 * Register hook getters for a schema source (integration module or page).
 * @param key - The schema key (module name like "job-sync" or "candidate-tracking")
 * @param registry - The hook registry
 */
export function registerSchemaHooks(
  key: string,
  registry: SchemaHookRegistry
): void {
  schemaRegistries.set(key.toLowerCase(), registry);
}

/** @deprecated Use registerSchemaHooks */
export const registerModuleHooks = registerSchemaHooks;

/**
 * Get the hook registry for a schema source.
 * @param key - The schema key (module name or page key)
 * @returns The hook registry, or undefined if not registered
 */
export function getSchemaHookRegistry(
  key: string | undefined
): SchemaHookRegistry | undefined {
  if (!key) return undefined;
  return schemaRegistries.get(key.toLowerCase());
}

/** @deprecated Use getSchemaHookRegistry */
export const getModuleHookRegistry = getSchemaHookRegistry;
